const italianProvinces = {
  'AG': 'Agrigento',
  'AL': 'Alessandria',
  'AN': 'Ancona',
  'AO': 'Aosta',
  'AR': 'Arezzo',
  'AP': 'Ascoli Piceno',
  'AT': 'Asti',
  'AV': 'Avellino',
  'BA': 'Bari',
  'BT': 'Barletta-Andria-Trani',
  'BL': 'Belluno',
  'BN': 'Benevento',
  'BG': 'Bergamo',
  'BI': 'Biella',
  'BO': 'Bologna',
  'BZ': 'Bolzano',
  'BS': 'Brescia',
  'BR': 'Brindisi',
  'CA': 'Cagliari',
  'CL': 'Caltanissetta',
  'CB': 'Campobasso',
  'CE': 'Caserta',
  'CT': 'Catania',
  'CZ': 'Catanzaro',
  'CH': 'Chieti',
  'CO': 'Como',
  'CS': 'Cosenza',
  'CR': 'Cremona',
  'KR': 'Crotone',
  'CN': 'Cuneo',
  'EN': 'Enna',
  'FM': 'Fermo',
  'FE': 'Ferrara',
  'FI': 'Firenze',
  'FG': 'Foggia',
  'FC': 'Forlì-Cesena',
  'FR': 'Frosinone',
  'GE': 'Genova',
  'GO': 'Gorizia',
  'GR': 'Grosseto',
  'IM': 'Imperia',
  'IS': 'Isernia',
  'SP': 'La Spezia',
  'AQ': 'L’Aquila',
  'LT': 'Latina',
  'LE': 'Lecce',
  'LC': 'Lecco',
  'LI': 'Livorno',
  'LO': 'Lodi',
  'LU': 'Lucca',
  'MC': 'Macerata',
  'MN': 'Mantova',
  'MS': 'Massa-Carrara',
  'MT': 'Matera',
  'ME': 'Messina',
  'MI': 'Milano',
  'MO': 'Modena',
  'MB': 'Monza e Brianza',
  'NA': 'Napoli',
  'NO': 'Novara',
  'NU': 'Nuoro',
  'OR': 'Oristano',
  'PD': 'Padova',
  'PA': 'Palermo',
  'PR': 'Parma',
  'PV': 'Pavia',
  'PG': 'Perugia',
  'PU': 'Pesaro e Urbino',
  'PE': 'Pescara',
  'PC': 'Piacenza',
  'PI': 'Pisa',
  'PT': 'Pistoia',
  'PN': 'Pordenone',
  'PZ': 'Potenza',
  'PO': 'Prato',
  'RG': 'Ragusa',
  'RA': 'Ravenna',
  'RC': 'Reggio Calabria',
  'RE': 'Reggio Emilia',
  'RI': 'Rieti',
  'RN': 'Rimini',
  'RM': 'Roma',
  'RO': 'Rovigo',
  'SA': 'Salerno',
  'SS': 'Sassari',
  'SV': 'Savona',
  'SI': 'Siena',
  'SR': 'Siracusa',
  'SO': 'Sondrio',
  'SU': 'Sud Sardegna',
  'TA': 'Taranto',
  'TE': 'Teramo',
  'TR': 'Terni',
  'TO': 'Torino',
  'TP': 'Trapani',
  'TN': 'Trento',
  'TV': 'Treviso',
  'TS': 'Trieste',
  'UD': 'Udine',
  'VA': 'Varese',
  'VE': 'Venezia',
  'VB': 'Verbano-Cusio-Ossola',
  'VC': 'Vercelli',
  'VR': 'Verona',
  'VV': 'Vibo Valentia',
  'VI': 'Vicenza',
  'VT': 'Viterbo'
};

const housetype = {
  'Appartamento': 'Appartamenti',
  'Villa': 'Ville',
  'Casa indipendente': 'Case indipendenti',
  'Rustico/Casale': 'Rustici/Casali',
  'Loft/Open Space': 'Loft/Open Space',
  'Attico': 'Attici',
  'Mansarda': 'Mansarde',
  'Palazzo/Stabile': ''
}

const COLLECTION_WEBSITE_ADS = 'websiteAds';
const COLLECTION_WEBSITE_ADS_V2 = 'websiteAdsV2';

const COLLECTION_AGENCY = "agencies";
// newarc-platform#2655: public agency card written by cloud functions; the
// signed-out pages read this instead of `agencies`.
const COLLECTION_AGENCY_PUBLIC_PROFILES = "agencyPublicProfiles";
// newarc-platform#3404: the same for a professional, read instead of `professionals`.
const COLLECTION_PROFESSIONAL_PUBLIC_PROFILES = "professionalPublicProfiles";
// newarc-platform#3451: public subset of renovation projects, Admin SDK writes.
const COLLECTION_NEWARC_PROJECT_PUBLIC_CARDS = "newarcProjectPublicCards";
const COLLECTION_USER = "users";
const COLLECTION_LEADS = "leads";
const COLLECTION_PROFESSIONALS = "professionals";
const COLLECTION_LIKED_ADS = "likedAds";
const COLLECTION_RENOVATION_CONTACT = "renovationContacts";
const COLLECTION_RENOVATION_QUOTATION = "renovationQuotation";
const COLLECTION_RENOVATION_CONTACT_ADDRESS = "renovationContactAddress";
// Shared, transactional source of truth for the PR_ quotation numbering:
// one document per `<regionCode>_<year>` holding `lastSeq`. Written by this
// site AND by newarc-platform (which also books numbers for the sopralluoghi,
// a collection the site cannot read) — see newarc-platform#2549.
const COLLECTION_RENOVATION_QUOTATION_CODE_COUNTERS =
  "renovationQuotationCodeCounters";
const COLLECTION_ADS_CONFIGURATION = "adsConfiguration";
const COLLECTION_NEWARC_HOMES = "newarcHomes";
const COLLECTION_MATERIOTECH = "newarcMateriotechSelections";
const COLLECTION_VIDEOCALL_REQUESTS = "videocallRequests";
// Visit requests ("Richiedi una visita") from the ad detail page. The platform
// (newarc-platform) reads this collection on /ads-manager/lead-acquisto with
// tag == 'agency'. Same collection the legacy WordPress form fed into.
const COLLECTION_WPFORMS_SUBMISSIONS = "wpformsSubmissions";


const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);



export { 
    italianProvinces, housetype, isMobile, 
    COLLECTION_WEBSITE_ADS,
    COLLECTION_WEBSITE_ADS_V2,
    COLLECTION_AGENCY,
    COLLECTION_AGENCY_PUBLIC_PROFILES,
    COLLECTION_PROFESSIONAL_PUBLIC_PROFILES,
    COLLECTION_NEWARC_PROJECT_PUBLIC_CARDS,
    COLLECTION_USER, 
    COLLECTION_LEADS, 
    COLLECTION_PROFESSIONALS, 
    COLLECTION_LIKED_ADS, 
    COLLECTION_RENOVATION_CONTACT, 
    COLLECTION_RENOVATION_QUOTATION, 
    COLLECTION_RENOVATION_CONTACT_ADDRESS,
    COLLECTION_RENOVATION_QUOTATION_CODE_COUNTERS,
    COLLECTION_ADS_CONFIGURATION,
    COLLECTION_NEWARC_HOMES,
    COLLECTION_MATERIOTECH,
    COLLECTION_VIDEOCALL_REQUESTS,
    COLLECTION_WPFORMS_SUBMISSIONS

}
